import { render, staticRenderFns } from "./promos.vue?vue&type=template&id=77626064&scoped=true"
import script from "./promos.vue?vue&type=script&lang=js"
export * from "./promos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77626064",
  null
  
)

export default component.exports